import {Component} from '@angular/core';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {IHeaderAngularComp} from 'ag-grid-angular';
import {IHeaderParams, RowNode} from 'ag-grid-community';
import {CheckboxCellEditorParams} from '../input/checkbox-cell-editor/checkbox-cell-editor-params.interface';

@Component({
  templateUrl: './header-checkbox-cell-renderer.component.html'
})
export class HeaderCheckboxCellRendererComponent implements IHeaderAngularComp {
  public checked = false;
  public indeterminate = false;

  private params: IHeaderParams;

  public agInit(params: IHeaderParams): void {
    this.params = params;
    this.updateStates();
  }

  public valueChanged(event: MatCheckboxChange): void {
    this.params.api.forEachNode((node: RowNode) => {
      node.setSelected(event.checked);
      node.data[this.getSelectedItemListName()].forEach((item: any) => (item.selected = event.checked));
    });

    this.params.api.refreshCells({force: true});
  }

  public refresh(_: IHeaderParams<any, any>): boolean {
    return true;
  }

  private getSelectedItemListName(): string {
    return (this.params.column.getColDef().cellRendererParams as CheckboxCellEditorParams).selectedItemListName;
  }

  private updateStates(): void {
    const listOfItems = this.params.api.getRenderedNodes().flatMap((node: RowNode) => node.data?.[this.getSelectedItemListName()] || []);
    const selectedItemsLength = listOfItems.filter((item: any) => item.selected).length;
    this.checked = selectedItemsLength > 0 && selectedItemsLength === listOfItems.length;
    this.indeterminate = selectedItemsLength > 0 && selectedItemsLength < listOfItems.length;
  }
}
